import { render, staticRenderFns } from "./el-breadcrumbs.vue?vue&type=template&id=2e606718&scoped=true&"
import script from "./el-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./el-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./el-breadcrumbs.vue?vue&type=style&index=0&id=2e606718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e606718",
  null
  
)

export default component.exports